import styled from 'styled-components';

export const CardContainer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 85px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin-bottom: 1rem;
`;

export const Date = styled.div`
  width: 85px;
  text-align: center;
  margin-left: 10px;
  border-left: 4px solid ${(props) => props.theme.colors.title};

  & p.day {
    font-style: normal;
    font-weight: 600;
    font-size: 26px;
  }
  & p.month {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-transform: uppercase;
  }
`;

export const Body = styled.div`
  padding: 10px 12px;
  width: 100%;

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.title};
  }

  p {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:not(:first-child) {
      display: none;
    }
  }

  @media ${(props) => props.theme.device.tabletL} {
    max-width: 121px;
    font-style: normal;
  }

  @media ${(props) => props.theme.device.mobileL} {
    max-width: 100%;
  }
`;

export const IconWrapper = styled.div`
  svg {
    fill: ${({ theme }) => theme.colors.title};
    stroke: ${({ theme }) => theme.colors.title};
  }
`;
